<template>
  <div>
    <el-upload
      action=""
      :on-preview="handlePictureCardPreview"
      :http-request="upload"
      :file-list="fileLists"
      multiple
      :on-remove="removeFileList"
    >
      <div class="uploading">附件上传</div>
    </el-upload>
  </div>
</template>
<script>
import { uploadAdmin } from '../../../../api/businessCenter'
import axios from 'axios'
export default {
  components: {},
  props: {
    fileList: {
      type: Array
    }
  },
  watch: {
    fileList(val) {
      // console.log(this.fileLists)
      // console.log(val)
      if (val) {
        this.fileLists = []
        val.forEach((item) => {
          // console.log(item)
          const ind = item.split('/')
          const na = item.split('/')[ind.length - 1]
          // console.log(item.split('/')[ind.length - 1])
          this.fileLists.push({
            name: na,
            url: item
          })
        })
      }

      // console.log(this.fileLists)
    }
  },
  data() {
    return {
      fileLists: []
    }
  },

  computed: {
    Authorization() {
      return sessionStorage.getItem('token')
    }
  },

  methods: {
    // 移除
    removeFileList(file, fileList) {
      // console.log(file)
      // console.log(fileList)
      // console.log(this.fileLists)
      this.$emit('removeUrl', file)
    },
    handlePictureCardPreview(file) {
      // console.log(file)
      const url = 'test/' + file.name
      axios({
        method: 'GET',
        url: process.env.VUE_APP_BASE_API + 'upload/uploadFile',
        params: { urlStr: url },
        responseType: 'blob',
        headers: {
          // 设置请求头
          token: this.Authorization
        }
      })
        .then((res) => {
          console.log(res)
          let blob = new Blob([res.data], {
            type: `application/msword`
          })
          let href = window.URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载'链接
          a.download = file.name //指定下载文件名
          a.click() //触发下载
          URL.revokeObjectURL(a.href) //释放URL对象
          document.body.removeChild(a) //释放标签
        })
        .catch(() => {
          //this.$message.error('文件下载失败')
        })
    },
    async upload(params) {
      const form = new FormData()
      form.append('files', params.file)
      const { data: res } = await uploadAdmin(form)
      // console.log(res.data)
      if (res.resultCode == 200) {
        const url = {
          url: res.data.fileLook[0],
          uid: params.file.uid
        }
        this.$emit('fileAddr', res.data.fileAddr[0]) // 短
        // this.$emit('fileLook', res.data.fileLook[0]) // 长
        this.$emit('fileLook', url) // 长
      }
    }
  },

  created() {},

  mounted() {}
}
</script>
<style scoped lang="less">
.uploading {
  width: 160px;
  height: 32px;
  background-color: #f0f0f0;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
/deep/.el-upload-list {
  width: 500px;
}
</style>
